import React from 'react';
import Routes from './router';
import './sass/main.scss';

const App = () => <Routes />;

export default App;
